/* eslint-disable */

import ApiClient from './ApiClient';
import {
  CompanyGoalResultsDto,
  GetUserGoalProgress$Request,
  GetCompanySignUpCode$Request,
  UserGoalResultId,
  CompanyStatistics,
  GetGoalsWithProgress$Response,
  GetNextSyncStartDateForActivity$Response,
  Gender,
  Logout$Response,
  LeaveGoal$Response,
  CreateGoal$Request,
  SetAppleHealthIntegration$Request,
  UploadAllAppleHealthActivities$Request,
  GetSpecificCompanyStatistics$Response,
  GetCompanyRankingFiltered$Request,
  DeleteGoal$Request,
  UserCustomDailyProgress,
  JoinCompany$Request,
  Lang,
  GetGoalGroupProgress$Request,
  GetLeaderboardGroups$Request,
  SaveGarminOauthRequestToken$Request,
  CalculateDailyStatistics$Request,
  CalculateGoalResults$Request,
  UpdateUserProfile$Response,
  JoinChat$Response,
  UpdateUserDateOfBirth$Response,
  GetUserGoalProgress$Response,
  SetOnboardingStatusToActivityData$Request,
  GetCompanyDivisions$Response,
  GetCompanyUsers$Response,
  GetCompanyGoalsProgress$Request,
  SignUp$Response,
  DeleteUserOwnedCompany$Response,
  GetCompanyDivisions$Request,
  ChangePassword$Response,
  UserProfileDto,
  GetGoogleFitAndroidSyncStart$Response,
  SaveGarminOauthRequestToken$Response,
  CompanyRankDto,
  GetNextSyncStartDateForActivity$Request,
  GetChatUserToken$Response,
  SetUserThirdPartyIntegration$Response,
  GetUserCurrentGoalProgress$Response,
  SetSyncEnabled$Request,
  UploadAllGoogleFitActivities$Response,
  EndUserThirdPartyIntegration$Request,
  CompanyStatistics$CompanyStepsStatistics,
  WhoAmI$Response,
  CreateUserOwnedCompany$Request,
  SetUserThirdPartyIntegration$Request,
  UserGoal,
  DeleteUser$Response,
  GetAppleHealthSyncStartAndEndDate$Response,
  UpdateProfileData$Request,
  Logout$Request,
  GetUserGoals$Response,
  GetUserGoals$Request,
  UserDailyProgress,
  OnboardingStatus,
  ProfileDto,
  CalculateGoalResultsForAll$Request,
  ApplicationContext,
  BadgeDto,
  GetLeaderboardGroups$Response,
  StepsCampaign$Request,
  ChangePassword$Request,
  GetCompanyActivityProgressInPeriod$Request,
  ToggleCompanyExcludedFromRanking$Response,
  UpdateActivityData$Response,
  GroupView,
  JoinGoal$Request,
  GoalRowWithUserProgress,
  GetAllCompanyGoals$Response,
  GetLeaderboardPeople$Response,
  Role,
  AppleHealthDiaryEntry,
  GetCompanyActivityProgressInPeriod$Response,
  GetCompanyGoalsProgress$Response,
  UserCompanyId,
  ServiceProvider,
  RedirectView,
  Login$Request,
  SetUserCountry$Request,
  CreateUser$Request,
  ChangeUserLanguage$Response,
  SignUp$Request,
  SetUserDivision$Response,
  DivisionId,
  GetChatUserToken$Request,
  GetUserProfile$Request,
  UserCompanyRolesDto,
  UserCompanyDto,
  UpdateProfileData$Response,
  CalculateUserGoalResult$Request,
  SendMail$Request,
  DivisionActivityProgress,
  GetCompanyGoalsInPeriod$Request,
  SetSyncEnabled$Response,
  GoalId,
  CustomType,
  SyncUsersInCompanyThirdPartyData$Response,
  DeleteGoal$Response,
  GetGoalCountryProgress$Response,
  GetUserBadges$Request,
  ChangeUserLanguage$Request,
  CalculateMonthlyResults$Response,
  CustomEntry$Request,
  GetGoalGroupProgress$Response,
  SyncUserThirdPartyData$Request,
  SyncUsersInCompanyThirdPartyData$Request,
  ExportGoalResults$Response,
  Login$Response,
  GetGoalsWithProgress$Request,
  CompanyCountriesDto,
  GetCompanyRanking$Request,
  GetSpecificCompanyUsers$Response,
  GetAllSpecificCompanyGoals$Request,
  UploadAppleHealthActivity$Response,
  SyncUserThirdPartyData$Response,
  UploadAppleHealthStepsAndCalories$Response,
  CustomEntry$Response,
  CalculateGoalResults$Response,
  DeleteUserFromGarmin$Response,
  DeleteUserFromGarmin$Request,
  FinalizeGarminIntegration$Response,
  GetCompanyGoalsInPeriod$Response,
  CalculateGoalResultsForAll$Response,
  PeriodType,
  CalculateMonthlyStatistics$Request,
  UpdateGoal$Request,
  UploadAllGoogleFitActivities$Request,
  GetUserCompanyCountries$Response,
  GetCompanyRankingFiltered$Response,
  SetOnboardingStatusToActivityData$Response,
  GetCompanyCountries$Request,
  GetUserDetailedProgress$Request,
  GoogleSignIn$Response,
  GetUserActivityProgressInPeriod$Request,
  GetUserCurrentGoalProgress$Request,
  JoinCompany$Response,
  GetGoalCountryProgress$Request,
  LastSyncDatePerActivityDto,
  CompanyStatistics$CompanyIntensiveMinutesStatistics,
  StepsCampaign$Response,
  GoogleSignIn$Request,
  UpdateUserDateOfBirth$Request,
  SetUserCountry$Response,
  GetGoalIndividualProgress$Request,
  GetLeaderboardPeople$Request,
  CalculateMonthlyResults$Request,
  ModuleLayer,
  Package,
  Module,
  GetUserDetailedProgress$Response,
  StartResetPassword$Response,
  GetUserProfile$Response,
  WhoAmI$Request,
  CalculateDailyStatistics$Response,
  LeaveGoal$Request,
  UpdateGoal$Response,
  AutowireCapableBeanFactory,
  LogString$Request,
  ToggleUserStatus$Response,
  AppleHealthActivityDto,
  LogString$Response,
  GetCompanyCountries$Response,
  SetNoIntegration$Request,
  DeleteUserOwnedCompany$Request,
  CalculateDailyResults$Response,
  CreateUserOwnedCompany$Response,
  GoalDto,
  GetCompanyStatistics$Response,
  CompanyId,
  GetCompanyStatistics$Request,
  UpdateUserProfile$Request,
  ToggleUserStatus$Request,
  GoalRow,
  ExportGoalResults$Request,
  DeleteUser$Request,
  ToggleCompanyExcludedFromRanking$Request,
  GetLeaderboardCountries$Response,
  CreateUser$Response,
  Annotation,
  GetAppleHealthSyncStartAndEndDate$Request,
  RegisterUser$Request,
  GetUserBadges$Response,
  CalculateAllActiveGoalResults$Response,
  RegisterUser$Response,
  GetUserCompanyCountries$Request,
  GetAppleHealthSyncStart$Request,
  GetUserCustomProgress$Response,
  GetSpecificCompanyStatistics$Request,
  DivisionDto,
  UpdateUserGender$Request,
  JoinGoal$Response,
  UserDto,
  LeaveCompany$Request,
  JoinChat$Request,
  SetAppleHealthIntegration$Response,
  CountryActivityProgress,
  UploadAllAppleHealthActivities$Response,
  SetNoIntegration$Response,
  CalculateDailyResults$Request,
  SensitiveString,
  EndUserThirdPartyIntegration$Response,
  GetCompanyUsers$Request,
  SetUserDivision$Request,
  FinalizeGarminIntegration$Request,
  MutableSession,
  Units,
  StartResetPassword$Request,
  GoalWithProgress,
  ResetPassword$Response,
  GetUserCustomProgress$Request,
  ProgressType,
  GetAllCompanyGoals$Request,
  CompanyStatistics$CompanyEnergyStatistics,
  Environment,
  UploadAppleHealthStepsAndCalories$Request,
  TogglePublicStatus$Response,
  GetAllUserGoals$Request,
  GetAllUserGoals$Response,
  GetCompanySignUpCode$Response,
  UploadAppleHealthActivity$Request,
  ResetPassword$Request,
  CalculateUserGoalResult$Response,
  GetGoalIndividualProgress$Response,
  GetCompanyRanking$Response,
  GetSpecificCompanyUsers$Request,
  BeanFactory,
  ClassLoader,
  GetLeaderboardCountries$Request,
  SendMail$Response,
  GetUserActivityProgressInPeriod$Response,
  UpdateUserGender$Response,
  CreateGoal$Response,
  CalculateMonthlyStatistics$Response,
  ActivityProgress,
  UpdateActivityData$Request,
  ActivityType,
  GetGoogleFitAndroidSyncStart$Request,
  TogglePublicStatus$Request,
  ModuleDescriptor,
  GetAllSpecificCompanyGoals$Response,
  UserId,
  CalculateAllActiveGoalResults$Request,
  LeaveCompany$Response,
  GetAppleHealthSyncStart$Response,
  GetAppleHealthSyncTimes$Request,
  GetUserDailyDiaryProgress$Request,
  GetUserDailyDiaryProgress$Response,
  SetOnboardingStatusToIntegration$Response,
  GetCompanyStatisticsByPeriod$Request,
  GetCompanyStatisticsByPeriod$Response,
  GetCompanyEmployees$Request,
  GetCompanyEmployees$Response,
  SetCompanyEmployees$Request,
  SetCompanyEmployees$Response,
  GetGoogleFitAndroidSyncTimes$Request, GetWhoAmI$Request, GetWhoAmI$Response, GetChallengesWithProgress$Request,
} from './api.types'
import { AxiosInstance, AxiosResponse } from 'axios';

export class ApiService {

    public users: UsersApiService;
    public activity: ActivityApiService;
    public statistics: StatisticsApiService;
    public auth: AuthApiService;

    constructor() {
        this.users = new UsersApiService(ApiClient);
        this.activity = new ActivityApiService(ApiClient);
        this.statistics = new StatisticsApiService(ApiClient);
        this.auth = new AuthApiService(ApiClient);
    }

}

export class UsersApiService {
    constructor(private api: AxiosInstance) {}

    changeUserLanguage = async (request: ChangeUserLanguage$Request): Promise<AxiosResponse<ChangeUserLanguage$Response>> => {
        return this.api.post('changeUserLanguage', request);
    }
    deleteUser = async (request: DeleteUser$Request): Promise<AxiosResponse<DeleteUser$Response>> => {
        return this.api.post('deleteUser', request);
    }
    deleteUserOwnedCompany = async (request: DeleteUserOwnedCompany$Request): Promise<AxiosResponse<DeleteUserOwnedCompany$Response>> => {
        return this.api.post('deleteUserOwnedCompany', request);
    }
    getCompanyCountries = async (): Promise<AxiosResponse<GetCompanyCountries$Response>> => {
        return this.api.post('getCompanyCountries');
    }
    getCompanyDivisions = async (): Promise<AxiosResponse<GetCompanyDivisions$Response>> => {
        return this.api.post('getCompanyDivisions');
    }
    getCompanySignUpCode = async (request: GetCompanySignUpCode$Request): Promise<AxiosResponse<GetCompanySignUpCode$Response>> => {
        return this.api.post('getCompanySignUpCode', request);
    }
    getCompanyEmployees = async (request: GetCompanyEmployees$Request): Promise<AxiosResponse<GetCompanyEmployees$Response>> => {
        return this.api.post('getCompanyEmployees', request);
    }
    setCompanyEmployees = async (request: SetCompanyEmployees$Request): Promise<AxiosResponse<SetCompanyEmployees$Response>> => {
        return this.api.post('setCompanyEmployees', request);
    }
    getCompanyUsers = async (): Promise<AxiosResponse<GetCompanyUsers$Response>> => {
        return this.api.post('getCompanyUsers');
    }
    getSpecificCompanyUsers = async (request: GetSpecificCompanyUsers$Request): Promise<AxiosResponse<GetSpecificCompanyUsers$Response>> => {
        return this.api.post('getSpecificCompanyUsers', request);
    }
    getUserCompanyCountries = async (): Promise<AxiosResponse<GetUserCompanyCountries$Response>> => {
        return this.api.post('getUserCompanyCountries');
    }
    leaveCompany = async (request: LeaveCompany$Request): Promise<AxiosResponse<LeaveCompany$Response>> => {
        return this.api.post('leaveCompany', request);
    }
    sendMail = async (request: SendMail$Request): Promise<AxiosResponse<SendMail$Response>> => {
        return this.api.post('sendMail', request);
    }
    setUserCountry = async (request: SetUserCountry$Request): Promise<AxiosResponse<SetUserCountry$Response>> => {
        return this.api.post('setUserCountry', request);
    }
    setUserDivision = async (request: SetUserDivision$Request): Promise<AxiosResponse<SetUserDivision$Response>> => {
        return this.api.post('setUserDivision', request);
    }
    toggleCompanyExcludedFromRanking = async (request: ToggleCompanyExcludedFromRanking$Request): Promise<AxiosResponse<ToggleCompanyExcludedFromRanking$Response>> => {
        return this.api.post('toggleCompanyExcludedFromRanking', request);
    }
    togglePublicStatus = async (): Promise<AxiosResponse<TogglePublicStatus$Response>> => {
        return this.api.post('togglePublicStatus');
    }
    toggleUserStatus = async (request: ToggleUserStatus$Request): Promise<AxiosResponse<ToggleUserStatus$Response>> => {
        return this.api.post('toggleUserStatus', request);
    }
    updateUserDateOfBirth = async (request: UpdateUserDateOfBirth$Request): Promise<AxiosResponse<UpdateUserDateOfBirth$Response>> => {
        return this.api.post('updateUserDateOfBirth', request);
    }
    updateUserGender = async (request: UpdateUserGender$Request): Promise<AxiosResponse<UpdateUserGender$Response>> => {
        return this.api.post('updateUserGender', request);
    }

}

export class ActivityApiService {
    constructor(private api: AxiosInstance) {}

    calculateAllActiveGoalResults = async (request: CalculateAllActiveGoalResults$Request): Promise<AxiosResponse<CalculateAllActiveGoalResults$Response>> => {
        return this.api.post('calculateAllActiveGoalResults', request);
    }
    calculateDailyResults = async (request: CalculateDailyResults$Request): Promise<AxiosResponse<CalculateDailyResults$Response>> => {
        return this.api.post('calculateDailyResults', request);
    }
    calculateGoalResults = async (request: CalculateGoalResults$Request): Promise<AxiosResponse<CalculateGoalResults$Response>> => {
        return this.api.post('calculateGoalResults', request);
    }
    calculateGoalResultsForAll = async (request: CalculateGoalResultsForAll$Request): Promise<AxiosResponse<CalculateGoalResultsForAll$Response>> => {
        return this.api.post('calculateGoalResultsForAll', request);
    }
    calculateMonthlyResults = async (request: CalculateMonthlyResults$Request): Promise<AxiosResponse<CalculateMonthlyResults$Response>> => {
        return this.api.post('calculateMonthlyResults', request);
    }
    calculateUserGoalResult = async (request: CalculateUserGoalResult$Request): Promise<AxiosResponse<CalculateUserGoalResult$Response>> => {
        return this.api.post('calculateUserGoalResult', request);
    }
    createGoal = async (request: CreateGoal$Request): Promise<AxiosResponse<CreateGoal$Response>> => {
        return this.api.post('createGoal', request);
    }
    customEntry = async (request: CustomEntry$Request): Promise<AxiosResponse<CustomEntry$Response>> => {
        return this.api.post('customEntry', request);
    }
    deleteGoal = async (request: DeleteGoal$Request): Promise<AxiosResponse<DeleteGoal$Response>> => {
        return this.api.post('deleteGoal', request);
    }
    deleteUserFromGarmin = async (request: DeleteUserFromGarmin$Request): Promise<AxiosResponse<DeleteUserFromGarmin$Response>> => {
        return this.api.post('deleteUserFromGarmin', request);
    }
    endUserThirdPartyIntegration = async (): Promise<AxiosResponse<EndUserThirdPartyIntegration$Response>> => {
        return this.api.post('endUserThirdPartyIntegration');
    }
    exportGoalResults = async (request: ExportGoalResults$Request): Promise<AxiosResponse<ExportGoalResults$Response>> => {
        return this.api.post('exportGoalResults', request);
    }
    finalizeGarminIntegration = async (request: FinalizeGarminIntegration$Request): Promise<AxiosResponse<FinalizeGarminIntegration$Response>> => {
        return this.api.post('finalizeGarminIntegration', request);
    }
    getAllCompanyGoals = async (): Promise<AxiosResponse<GetAllCompanyGoals$Response>> => {
        return this.api.post('getAllCompanyGoals');
    }
    getAllSpecificCompanyGoals = async (request: GetAllSpecificCompanyGoals$Request): Promise<AxiosResponse<GetAllSpecificCompanyGoals$Response>> => {
        return this.api.post('getAllSpecificCompanyGoals', request);
    }
    getAllUserGoals = async (request: GetAllUserGoals$Request): Promise<AxiosResponse<GetAllUserGoals$Response>> => {
        return this.api.post('getAllUserGoals', request);
    }
    getAppleHealthSyncStart = async (): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getAppleHealthSyncStart');
    }
    getAppleHealthSyncTimes = async (request: GetAppleHealthSyncTimes$Request): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getAppleHealthSyncTimes', request);
    }
    getGoogleFitAndroidSyncTimes = async (request: GetGoogleFitAndroidSyncTimes$Request): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getGoogleFitAndroidSyncTimes', request);
    }
    getAppleHealthSyncStartAndEndDate = async (): Promise<AxiosResponse<GetAppleHealthSyncStartAndEndDate$Response>> => {
        return this.api.post('getAppleHealthSyncStartAndEndDate');
    }
    getChatUserToken = async (): Promise<AxiosResponse<GetChatUserToken$Response>> => {
        return this.api.post('getChatUserToken');
    }
    getCompanyActivityProgressInPeriod = async (request: GetCompanyActivityProgressInPeriod$Request): Promise<AxiosResponse<GetCompanyActivityProgressInPeriod$Response>> => {
        return this.api.post('getCompanyActivityProgressInPeriod', request);
    }
    getCompanyGoalsInPeriod = async (request: GetCompanyGoalsInPeriod$Request): Promise<AxiosResponse<GetCompanyGoalsInPeriod$Response>> => {
        return this.api.post('getCompanyGoalsInPeriod', request);
    }
    getCompanyGoalsProgress = async (request: GetCompanyGoalsProgress$Request): Promise<AxiosResponse<GetCompanyGoalsProgress$Response>> => {
        return this.api.post('getCompanyGoalsProgress', request);
    }
    getCompanyRanking = async (): Promise<AxiosResponse<GetCompanyRanking$Response>> => {
        return this.api.post('getCompanyRanking');
    }
    getCompanyRankingFiltered = async (request: GetCompanyRankingFiltered$Request): Promise<AxiosResponse<GetCompanyRankingFiltered$Response>> => {
        return this.api.post('getCompanyRankingFiltered', request);
    }
    getCompanyStatistics = async (): Promise<AxiosResponse<GetCompanyStatistics$Response>> => {
        return this.api.post('getCompanyStatistics');
    }
    getGoalCountryProgress = async (request: GetGoalCountryProgress$Request): Promise<AxiosResponse<GetGoalCountryProgress$Response>> => {
        return this.api.post('getGoalCountryProgress', request);
    }
    getGoalGroupProgress = async (request: GetGoalGroupProgress$Request): Promise<AxiosResponse<GetGoalGroupProgress$Response>> => {
        return this.api.post('getGoalGroupProgress', request);
    }
    getGoalIndividualProgress = async (request: GetGoalIndividualProgress$Request): Promise<AxiosResponse<GetGoalIndividualProgress$Response>> => {
        return this.api.post('getGoalIndividualProgress', request);
    }
    getGoalsWithProgress = async (): Promise<AxiosResponse<GetGoalsWithProgress$Response>> => {
        return this.api.post('getGoalsWithProgress');
    }
    getChallengesWithProgress = async (request: GetChallengesWithProgress$Request): Promise<AxiosResponse<GetGoalsWithProgress$Response>> => {
        return this.api.post('getChallengesWithProgress', request);
    }
    getGoogleFitAndroidSyncStart = async (): Promise<AxiosResponse<GetGoogleFitAndroidSyncStart$Response>> => {
        return this.api.post('getGoogleFitAndroidSyncStart');
    }
    getLeaderboardCountries = async (request: GetLeaderboardCountries$Request): Promise<AxiosResponse<GetLeaderboardCountries$Response>> => {
        return this.api.post('getLeaderboardCountries', request);
    }
    getLeaderboardGroups = async (request: GetLeaderboardGroups$Request): Promise<AxiosResponse<GetLeaderboardGroups$Response>> => {
        return this.api.post('getLeaderboardGroups', request);
    }
    getLeaderboardPeople = async (request: GetLeaderboardPeople$Request): Promise<AxiosResponse<GetLeaderboardPeople$Response>> => {
        return this.api.post('getLeaderboardPeople', request);
    }
    getNextSyncStartDateForActivity = async (request: GetNextSyncStartDateForActivity$Request): Promise<AxiosResponse<GetNextSyncStartDateForActivity$Response>> => {
        return this.api.post('getNextSyncStartDateForActivity', request);
    }
    getSpecificCompanyStatistics = async (request: GetSpecificCompanyStatistics$Request): Promise<AxiosResponse<GetSpecificCompanyStatistics$Response>> => {
        return this.api.post('getSpecificCompanyStatistics', request);
    }
    getUserActivityProgressInPeriod = async (request: GetUserActivityProgressInPeriod$Request): Promise<AxiosResponse<GetUserActivityProgressInPeriod$Response>> => {
        return this.api.post('getUserActivityProgressInPeriod', request);
    }
    getUserBadges = async (request: GetUserBadges$Request): Promise<AxiosResponse<GetUserBadges$Response>> => {
        return this.api.post('getUserBadges', request);
    }
    getUserCurrentGoalProgress = async (request: GetUserCurrentGoalProgress$Request): Promise<AxiosResponse<GetUserCurrentGoalProgress$Response>> => {
        return this.api.post('getUserCurrentGoalProgress', request);
    }
    getUserCustomProgress = async (request: GetUserCustomProgress$Request): Promise<AxiosResponse<GetUserCustomProgress$Response>> => {
        return this.api.post('getUserCustomProgress', request);
    }
    getUserDailyDiaryProgress = async (request: GetUserDailyDiaryProgress$Request): Promise<AxiosResponse<GetUserDailyDiaryProgress$Response>> => {
        return this.api.post('getUserDailyDiaryProgress', request);
    }
    getUserDetailedProgress = async (request: GetUserDetailedProgress$Request): Promise<AxiosResponse<GetUserDetailedProgress$Response>> => {
        return this.api.post('getUserDetailedProgress', request);
    }
    getUserGoalProgress = async (request: GetUserGoalProgress$Request): Promise<AxiosResponse<GetUserGoalProgress$Response>> => {
        return this.api.post('getUserGoalProgress', request);
    }
    getUserGoals = async (request: GetUserGoals$Request): Promise<AxiosResponse<GetUserGoals$Response>> => {
        return this.api.post('getUserGoals', request);
    }
    getUserProfile = async (): Promise<AxiosResponse<GetUserProfile$Response>> => {
        return this.api.post('getUserProfile');
    }
    joinChat = async (request: JoinChat$Request): Promise<AxiosResponse<JoinChat$Response>> => {
        return this.api.post('joinChat', request);
    }
    joinCompany = async (request: JoinCompany$Request): Promise<AxiosResponse<JoinCompany$Response>> => {
        return this.api.post('joinCompany', request);
    }
    joinGoal = async (request: JoinGoal$Request): Promise<AxiosResponse<JoinGoal$Response>> => {
        return this.api.post('joinGoal', request);
    }
    leaveGoal = async (request: LeaveGoal$Request): Promise<AxiosResponse<LeaveGoal$Response>> => {
        return this.api.post('leaveGoal', request);
    }
    saveGarminOauthRequestToken = async (request: SaveGarminOauthRequestToken$Request): Promise<AxiosResponse<SaveGarminOauthRequestToken$Response>> => {
        return this.api.post('saveGarminOauthRequestToken', request);
    }
    setAppleHealthIntegration = async (): Promise<AxiosResponse<SetAppleHealthIntegration$Response>> => {
        return this.api.post('setAppleHealthIntegration');
    }
    setNoIntegration = async (): Promise<AxiosResponse<SetNoIntegration$Response>> => {
        return this.api.post('setNoIntegration');
    }
    setOnboardingStatusToActivityData = async (): Promise<AxiosResponse<SetOnboardingStatusToActivityData$Response>> => {
        return this.api.post('setOnboardingStatusToActivityData');
    }
    setOnboardingStatusToIntegration = async (): Promise<AxiosResponse<SetOnboardingStatusToIntegration$Response>> => {
        return this.api.post('setOnboardingStatusToIntegration');
    }
    setSyncEnabled = async (request: SetSyncEnabled$Request): Promise<AxiosResponse<SetSyncEnabled$Response>> => {
        return this.api.post('setSyncEnabled', request);
    }
    setUserThirdPartyIntegration = async (request: SetUserThirdPartyIntegration$Request): Promise<AxiosResponse<SetUserThirdPartyIntegration$Response>> => {
        return this.api.post('setUserThirdPartyIntegration', request);
    }
    stepsCampaign = async (): Promise<AxiosResponse<StepsCampaign$Response>> => {
        return this.api.post('stepsCampaign');
    }
    syncUserThirdPartyData = async (): Promise<AxiosResponse<SyncUserThirdPartyData$Response>> => {
        return this.api.post('syncUserThirdPartyData');
    }
    syncUsersInCompanyThirdPartyData = async (request: SyncUsersInCompanyThirdPartyData$Request): Promise<AxiosResponse<SyncUsersInCompanyThirdPartyData$Response>> => {
        return this.api.post('syncUsersInCompanyThirdPartyData', request);
    }
    updateActivityData = async (request: UpdateActivityData$Request): Promise<AxiosResponse<UpdateActivityData$Response>> => {
        return this.api.post('updateActivityData', request);
    }
    updateGoal = async (request: UpdateGoal$Request): Promise<AxiosResponse<UpdateGoal$Response>> => {
        return this.api.post('updateGoal', request);
    }
    updateProfileData = async (request: UpdateProfileData$Request): Promise<AxiosResponse<UpdateProfileData$Response>> => {
        return this.api.post('updateProfileData', request);
    }
    updateUserProfile = async (request: UpdateUserProfile$Request): Promise<AxiosResponse<UpdateUserProfile$Response>> => {
        return this.api.post('updateUserProfile', request);
    }
    uploadAllAppleHealthActivities = async (request: UploadAllAppleHealthActivities$Request): Promise<AxiosResponse<UploadAllAppleHealthActivities$Response>> => {
        return this.api.post('uploadAllAppleHealthActivities', request);
    }
    uploadAllGoogleFitActivities = async (request: UploadAllGoogleFitActivities$Request): Promise<AxiosResponse<UploadAllGoogleFitActivities$Response>> => {
        return this.api.post('uploadAllGoogleFitActivities', request);
    }
    uploadAppleHealthActivity = async (request: UploadAppleHealthActivity$Request): Promise<AxiosResponse<UploadAppleHealthActivity$Response>> => {
        return this.api.post('uploadAppleHealthActivity', request);
    }
    uploadAppleHealthStepsAndCalories = async (request: UploadAppleHealthStepsAndCalories$Request): Promise<AxiosResponse<UploadAppleHealthStepsAndCalories$Response>> => {
        return this.api.post('uploadAppleHealthStepsAndCalories', request);
    }

}

export class StatisticsApiService {
    constructor(private api: AxiosInstance) {}

    calculateDailyStatistics = async (request: CalculateDailyStatistics$Request): Promise<AxiosResponse<CalculateDailyStatistics$Response>> => {
        return this.api.post('calculateDailyStatistics', request);
    }
    calculateMonthlyStatistics = async (request: CalculateMonthlyStatistics$Request): Promise<AxiosResponse<CalculateMonthlyStatistics$Response>> => {
        return this.api.post('calculateMonthlyStatistics', request);
    }
    getCompanyStatisticsByPeriod = async (request: GetCompanyStatisticsByPeriod$Request): Promise<AxiosResponse<GetCompanyStatisticsByPeriod$Response>> => {
        return this.api.post('getCompanyStatisticsByPeriod', request);
    }

}

export class AuthApiService {
    constructor(private api: AxiosInstance) {}

    changePassword = async (request: ChangePassword$Request): Promise<AxiosResponse<ChangePassword$Response>> => {
        return this.api.post('changePassword', request);
    }
    createUser = async (request: CreateUser$Request): Promise<AxiosResponse<CreateUser$Response>> => {
        return this.api.post('createUser', request);
    }
    createUserOwnedCompany = async (request: CreateUserOwnedCompany$Request): Promise<AxiosResponse<CreateUserOwnedCompany$Response>> => {
        return this.api.post('createUserOwnedCompany', request);
    }
    googleSignIn = async (request: GoogleSignIn$Request): Promise<AxiosResponse<GoogleSignIn$Response>> => {
        return this.api.post('googleSignIn', request);
    }
    logString = async (request: LogString$Request): Promise<AxiosResponse<LogString$Response>> => {
        return this.api.post('logString', request);
    }
    login = async (request: Login$Request): Promise<AxiosResponse<Login$Response>> => {
        return this.api.post('login', request);
    }
    logout = async (): Promise<AxiosResponse<Logout$Response>> => {
        return this.api.post('logout');
    }
    registerUser = async (request: RegisterUser$Request): Promise<AxiosResponse<RegisterUser$Response>> => {
        return this.api.post('registerUser', request);
    }
    resetPassword = async (request: ResetPassword$Request): Promise<AxiosResponse<ResetPassword$Response>> => {
        return this.api.post('resetPassword', request);
    }
    signUp = async (request: SignUp$Request): Promise<AxiosResponse<SignUp$Response>> => {
        return this.api.post('signUp', request);
    }
    startResetPassword = async (request: StartResetPassword$Request): Promise<AxiosResponse<StartResetPassword$Response>> => {
        return this.api.post('startResetPassword', request);
    }
    whoAmI = async (): Promise<AxiosResponse<WhoAmI$Response>> => {
        return this.api.post('whoAmI');
    }
    getWhoAmI = async (request: GetWhoAmI$Request): Promise<AxiosResponse<GetWhoAmI$Response>> => {
        return this.api.post('getWhoAmI', request);
    }

}

const api = new ApiService();
export default api;
